import React, { createContext, useContext, useState } from "react";

const CursorContext = createContext(null);

export const CursorProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [isWhite, setIsWhite] = useState(false);

  return (
    <CursorContext.Provider
      value={{
        visible,
        show: () => setVisible(true),
        hide: () => setVisible(false),
        isWhite,
        setWhite: () => setIsWhite(true),
        setDark: () => setIsWhite(false),
      }}
    >
      {children}
    </CursorContext.Provider>
  );
};

export const useCursor = () => {
  const ctx = useContext(CursorContext);
  if (!ctx) throw new Error("useCursor must be used within CursorProvider");
  return ctx;
};
